import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Layout from './components/Layout';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Logs from './pages/Logs';
import LogForm from './pages/LogForm';
import KPIs from './pages/KPIs';
import Profile from './pages/Profile';
import SupervisorDashboard from './pages/supervisor/Dashboard';
import Approvals from './pages/supervisor/Approvals';
import TeamKPIs from './pages/supervisor/TeamKPIs';
import Users from './pages/admin/Users';
import Drivers from './pages/admin/Drivers';

function PrivateRoute({ children, roles = [] }) {
  const { user, isAuthenticated } = useSelector((state) => state.auth);

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (roles.length > 0 && !roles.includes(user?.role?.name)) {
    return <Navigate to="/dashboard" />;
  }

  return children;
}

function App() {
  const { isAuthenticated } = useSelector((state) => state.auth);

  return (
    <Routes>
      {/* Public routes */}
      <Route
        path="/login"
        element={isAuthenticated ? <Navigate to="/dashboard" /> : <Login />}
      />
      <Route
        path="/register"
        element={isAuthenticated ? <Navigate to="/dashboard" /> : <Register />}
      />

      {/* Protected routes */}
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="logs" element={<Logs />} />
        <Route path="logs/new" element={<LogForm />} />
        <Route path="logs/:id" element={<LogForm />} />
        <Route path="kpis" element={<KPIs />} />
        <Route path="profile" element={<Profile />} />

        {/* Supervisor routes */}
        <Route
          path="supervisor"
          element={
            <PrivateRoute roles={['supervisor', 'admin']}>
              <SupervisorDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="supervisor/approvals"
          element={
            <PrivateRoute roles={['supervisor', 'admin']}>
              <Approvals />
            </PrivateRoute>
          }
        />
        <Route
          path="supervisor/team-kpis"
          element={
            <PrivateRoute roles={['supervisor', 'admin']}>
              <TeamKPIs />
            </PrivateRoute>
          }
        />

        {/* Admin routes - /admin redirects to dashboard */}
        <Route path="admin" element={<Navigate to="/dashboard" />} />
        <Route
          path="admin/users"
          element={
            <PrivateRoute roles={['admin']}>
              <Users />
            </PrivateRoute>
          }
        />
        <Route
          path="admin/drivers"
          element={
            <PrivateRoute roles={['admin']}>
              <Drivers />
            </PrivateRoute>
          }
        />
      </Route>

      {/* 404 */}
      <Route path="*" element={<Navigate to="/dashboard" />} />
    </Routes>
  );
}

export default App;
